import { AlertTriangle } from "lucide-react";

export default function AiDecisionNotice({ className = "" }) {
  return (
    <div
      className={`rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm leading-6 text-amber-900 ${className}`}
    >
      <div className="flex gap-3">
        <AlertTriangle className="mt-0.5 flex-shrink-0" size={18} />
        <p>
          AI rankings, scores, summaries, strengths, and gaps are decision-support
          outputs. They can be wrong or incomplete, so recruiters should review
          the original CV and make the final hiring decision themselves.
        </p>
      </div>
    </div>
  );
}
